export const LOAD_PRODUCT_REVIEW_DATA = 'productDataReviewWizard/LOAD_PRODUCT_REVIEW_DATA';
export const UPDATE_PRODUCT_REVIEW_DATA = 'productDataReviewWizard/UPDATE_PRODUCT_REVIEW_DATA';
